import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/metaverse-new/toolkit_meta.webp";

function Metaversetoolkit() {
  return (
    <section
      className="metaverse_toolkit p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Toolkit We Use for Metaverse Development Services</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="tech_stack_meta">
              <div className="meta_stack_item">
                <div className="meta_stack_img">
                  <StaticImage
                    src="../../images/services-usa/metaverse-new/unreal_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="meta_stack_head">
                  <h6>Unreal Engine</h6>
                </div>
              </div>
              <div className="meta_stack_item">
                <div className="meta_stack_img">
                  <StaticImage
                    src="../../images/services-usa/metaverse-new/unity_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="meta_stack_head">
                  <h6>Unity</h6>
                </div>
              </div>
              <div className="meta_stack_item">
                <div className="meta_stack_img">
                  <StaticImage
                    src="../../images/services-usa/metaverse-new/blockchain_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="meta_stack_head">
                  <h6>Blockchain</h6>
                </div>
              </div>
              <div className="meta_stack_item">
                <div className="meta_stack_img">
                  <StaticImage
                    src="../../images/services-usa/metaverse-new/nft_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="meta_stack_head">
                  <h6>NFTs</h6>
                </div>
              </div>
              <div className="meta_stack_item">
                <div className="meta_stack_img">
                  <StaticImage
                    src="../../images/services-usa/metaverse-new/webxr_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="meta_stack_head">
                  <h6>WebXR</h6>
                </div>
              </div>
              <div className="meta_stack_item">
                <div className="meta_stack_img">
                  <StaticImage
                    src="../../images/services-usa/metaverse-new/horizon_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="meta_stack_head">
                  <h6>Facebook Horizon</h6>
                </div>
              </div>
              <div className="meta_stack_item">
                <div className="meta_stack_img">
                  <StaticImage
                    src="../../images/services-usa/metaverse-new/blender_logo.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={160}
                    height={160}
                  />
                </div>
                <div className="meta_stack_head">
                  <h6>Blender</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Metaversetoolkit;
